import { Card, CardContent, Skeleton, Typography } from '@mui/material'

type Props = {
  title?: string
}
export const BarChartLoading = ({ title }: Props) => {
  return (
    <Card sx={{ height: '100%', minHeight: 400, boxShadow: 2, borderRadius: 2 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: '#2D3748',
            mb: 3,
          }}
        >
          {title}
        </Typography>
        <Skeleton variant="rectangular" height={320} sx={{ borderRadius: '8px' }} />
      </CardContent>
    </Card>
  )
}
